import React, { useState, useEffect } from 'react'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const SelectMUI = ({ label, value, name, id, onChange, size, data, noOption, required, disabled }) => {
    const [inputValue, setInputValue] = useState("")

    const inputChange = (e) => {
        setInputValue(e.target.value)
        onChange(e.target.value)
    }

    useEffect(() => {
        setInputValue(value)
    }, [value])

    return (
        <FormControl
            fullWidth
            size={size !== undefined ? size : ''}
            variant="standard"
            sx={{
                paddingBottom: "12px",
                '& .MuiInputBase-root': {
                    fontSize: '16px', 
                    paddingBottom: '8px',
                },
                '& .MuiInputLabel-root': {
                    fontSize: '14px',
                }
            }}
        >
            <InputLabel
                required={required !== undefined ? required : false}
                id={id !== undefined ? id : ''}
            >
                {label !== undefined ? label : ''}
            </InputLabel>

            <Select
                labelId={id !== undefined ? id : ''}
                value={inputValue !== null ? inputValue : ''}
                label={label !== undefined ? label : ''}
                onChange={e => inputChange(e)}
                name={name !== undefined ? name : ''}
                id={id !== undefined ? id : ''}
                required={required !== undefined ? required : false}
                disabled={disabled ? disabled : false}
            >
                <MenuItem value={''}>{noOption || 'Select Option'}</MenuItem>
                {data !== undefined && data.length > 0 &&
                    data.map((item, i) => (
                        <MenuItem key={i} value={item} sx={{ fontSize: '16px' }}>
                            {item}
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
}

export default SelectMUI;
